import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ToggleTranslateButton } from 'shared/ui/toggle-translate-button';
import { usePermission, MENU } from 'shared/lib/permissions';
import useModalState from 'shared/hooks/useModalState';
import { setProgressModalOpen } from 'store/buku-tarif/bukuTarifSlice';
import {
  ModalUploadTariffBook,
  ModalProgressUpload,
} from 'features/buku-tarif/upload';
import { TariffBookTable } from '../components/tariff-book-table';
import { useTariffBookList } from '../hooks/useTariffBookList';

const TariffBookListPage = () => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const uploadModal = useModalState();
  const isProgressModalOpen = useSelector(
    (state) => state.bukuTarif.isProgressModalOpen
  );
  const { canCreate } = usePermission(MENU.BUKU_TARIF);
  const listState = useTariffBookList();

  return (
    <>
      <header className="flex justify-between items-center pt-8 pl-6 pb-4 w-[96%]">
        <h1 className="text-lg font-semibold">{t('tarif_book')}</h1>
        <ToggleTranslateButton className="!h-10" />
      </header>
      <div className="flex-grow overflow-auto px-6">
        <TariffBookTable
          {...listState}
          onUploadClick={uploadModal.openModal}
          canCreate={canCreate}
        />
      </div>
      <ModalUploadTariffBook
        isOpen={uploadModal.isOpen}
        onClose={uploadModal.closeModal}
      />
      <ModalProgressUpload
        isOpen={isProgressModalOpen}
        onClose={() => dispatch(setProgressModalOpen(false))}
      />
    </>
  );
};

export default TariffBookListPage;
